import {Flex, Icon, Text, useColorModeValue, useDisclosure} from "@chakra-ui/react";
import Card from "components/Card/Card";
import CardBody from "components/Card/CardBody";
import IconBox from "components/Icons/IconBox";
import React, {useEffect, useState} from "react";
import {BsMic} from "react-icons/bs";
import {keyframes} from "@emotion/react";
import RecordSettingsModal from "./RecordSettingsModal";
import FreemiumExpiredModal from "./FreemiumExpiredModal";

const RecordWidget = ({
                        user
                      }) => {
  const {isOpen, onOpen, onClose} = useDisclosure();
  const [componentHovered, setComponentHovered] = useState(false);
  const bounce = keyframes`
      0%, 100% {
          transform: translateY(0);
      }
      50% {
          transform: translateY(-10px);
      }
  `;

  async function cleanupMicrophone() {
    const mediaStream = await navigator.mediaDevices.getUserMedia({audio: true});
    mediaStream.getTracks().forEach((track) => track.stop());
  }

  return (
    <>
      <Card
        cursor="pointer"
        bg="var(--primary-color)"
        onMouseEnter={() => setComponentHovered(true)}
        onMouseLeave={() => setComponentHovered(false)}
        _hover={{
          bg: "rgba(255, 0, 0, 0.3)",
        }}
        onClick={onOpen}
      >
        <CardBody>
          <Flex justify="space-between" w="100%" align="center">
            <Flex direction="column">
              <Text fontSize="sm" color="#fff" fontWeight="normal" mb="2px">
                {`Realtime notuleren`}
              </Text>
              <Text fontSize="lg" color="#fff" fontWeight="bold">
                {`Klik hier om uw notule te starten`}
              </Text>
            </Flex>
            <IconBox as="box" h={"45px"} w={"45px"} bg="white">
              <Icon
                as={BsMic}
                h={"24px"}
                w={"24px"}
                color={componentHovered ? `rgba(255, 0, 0, 0.3)` : `var(--primary-color)`}
                animation={componentHovered === true ? `${bounce} 1s infinite ease-in-out` : undefined}
              />
            </IconBox>
          </Flex>
        </CardBody>
      </Card>
      {(user?.hasSubscription || user?.freemiumSeconds > 120) ? (
          <RecordSettingsModal isOpen={isOpen} onClose={onClose} onOpen={onOpen} user={user}/>
        ) :
        <FreemiumExpiredModal isOpen={isOpen} onClose={onClose} opOpen={onOpen} user={user}/>
      }
    </>
  );
};

export default RecordWidget;
